import * as React from "react";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { useMount } from "../../../../utils/custom-hooks";
import { ServiceProviderR } from "../routes";
import {
  BannerNoticeService,
  BannerNoticeServiceProps,
} from "../../../../application/service/service-provider/banner-notice-service";
import { matchType } from "../../../../application/domain/base/base-type";
import { Field, FieldProps, Formik } from "formik";
import { PrimaryButton } from "@graffer-inc/console-design-kit";
import dayjs from "../../../../utils/date-utils";

export const BannerNoticePage: React.FC<BannerNoticeServiceProps> = ({
  isLoading,
  onMount,
  currentSetting,
  onDelete,
  onSave,
}) => {
  useMount(() => {
    onMount();
  });

  return (
    <ServiceProviderTemplate
      breadcrumbs={[
        { to: ServiceProviderR.Home.link({}), title: "バナー通知表示設定" },
      ]}
    >
      <nav className="level">
        <div className="level-left">
          <div className="level-item">
            <h1 className="is-size-2">バナー通知表示設定</h1>
          </div>
        </div>
      </nav>
      {matchType(isLoading ? "loading" : "loaded", {
        loading: "読込中",
        loaded: (
          <>
            <h2 className="title is-size-4">現在の設定</h2>
            {currentSetting ? (
              <>
                <p>cosmicjsのslug: {currentSetting.cosmicJSSlug}</p>
                <p>
                  表示時期:
                  {`${currentSetting.displayUntil}`}
                </p>
                <button className="button is-info" onClick={onDelete}>
                  設定を解除する
                </button>
              </>
            ) : (
              <p>設定はありません</p>
            )}
            <h2 className="title is-size-4 mt-6">設定フォーム</h2>
            <div
              style={{
                maxWidth: "300px",
              }}
            >
              <Formik
                initialValues={
                  currentSetting || {
                    cosmicJSSlug: "",
                    displayUntil: dayjs()
                      .add(14, "day")
                      .format("YYYY-MM-DDTHH:mm:ss"),
                  }
                }
                onSubmit={async (values) => {
                  await new Promise((resolve) => setTimeout(resolve, 500));
                  onSave({
                    ...values,
                    displayUntil: dayjs(
                      values.displayUntil,
                      "YYYY-MM-DDTHH:mm:ss",
                    ).toDate(),
                  });
                }}
              >
                {(props) => {
                  const { isSubmitting, handleSubmit } = props;
                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="field">
                        <label className="label">CosmicJSのSlug</label>
                        <Field className="control" name="cosmicJSSlug">
                          {({ field, form }: FieldProps) => (
                            <>
                              <input
                                className="input"
                                {...field}
                                placeholder="CosmicJSのSlug"
                              />
                              <p className="help is-danger">
                                {form.touched.slug &&
                                  form.errors.slug &&
                                  `${form.errors.slug}`}
                              </p>
                            </>
                          )}
                        </Field>
                      </div>
                      <div className="field">
                        <label className="label">表示終了時間</label>
                        <Field className="control" name="displayUntil">
                          {({ field, form }: FieldProps) => (
                            <>
                              <input
                                type="datetime-local"
                                className="input"
                                {...field}
                                placeholder=""
                              />
                              <p className="help is-danger">
                                {form.touched.displayUntil &&
                                  form.errors.displayUntil &&
                                  `${form.errors.displayUntil}`}
                              </p>
                            </>
                          )}
                        </Field>
                      </div>
                      <PrimaryButton
                        text={"設定する"}
                        disabled={isSubmitting}
                      />
                    </form>
                  );
                }}
              </Formik>
            </div>
          </>
        ),
      })}
    </ServiceProviderTemplate>
  );
};

export const BannerNoticePageContainer = connectPageService(
  BannerNoticePage,
  () => new BannerNoticeService(),
);
